import React, { useState } from 'react';
import { Picker } from 'antd-mobile';
import { useMounted } from '@/utils/hooks';

// 如果不是使用 List.Item 作为 children
const CustomChildren = props => (
  <p className={props.className} onClick={props.onClick}>
    {props.extra}
  </p>
);

const RecommendPicker = ({ cols = 1, value, childrenClassName, onConfirm, ...restConfig }) => {
  const [curValue, setCurVal] = useState([]);
  const handlePickerConfirm = val => {
    setCurVal(val);
    onConfirm(val);
  };

  useMounted(() => setCurVal(value));

  return (
    <Picker cols={cols} value={curValue} {...restConfig} onOk={handlePickerConfirm}>
      <CustomChildren className={childrenClassName} />
      {/* <p className={childrenClassName}>{title}</p> */}
    </Picker>
  );
};
export default RecommendPicker;
